const routerArr = [
    {
        path: '/downloadApk',
        name: 'downloadApk',
        meta: { title:'咚咚燕助手' , login:false },
        component: () => import(/* webpackChunkName: 'mh_homepage' */ './page/downloadApk.vue'),
    }
]

export default routerArr;